<template>
    <div class="deviceConf">
        <page-header></page-header>
        <div class="set-option">
            <template>
                <el-select class="charts-input" v-model="option.sys_alias" @change="changeOption(true)"
                           placeholder="请选择">
                    <el-option v-for="item in sys_alias" :key="item.id" :label="item.label" :value="item.val">
                    </el-option>
                </el-select>
            </template>
            <div class="charts-input"   >
                <el-button  type='primary' :loading="loading" @click="changeOption(false)">{{loading ? '正在加载' : '手动刷新'}}</el-button>
            </div>
        </div>
        <div class="css-margin-top controlSet">
            <el-card class="box-card" body-style>
                <div class="clearfix chars-header">
                    <span class="card-header-title">设备配置表</span>
                    <span class="time-show">{{deviceConf.time_stamp}}</span>
                    <span></span>
                    <!--<div v-if="!isEdit">-->
                        <!--<el-button @click="openEdit" type="text">编辑</el-button>-->
                    <!--</div>-->
                    <!--<div v-else>-->
                        <!--<el-button v-show="isEdit" @click="isEdit=false" type="text">取消</el-button>-->
                        <!--<el-button @click="saveDeviceConf" :loading="loading" v-show="isEdit" type="success">-->
                            <!--{{loading ? '正在加载' : '保存并写入设备'}}-->
                        <!--</el-button>-->
                    <!--</div>-->
                </div>
                <div v-if="!loading">
                    <div v-if="!isMobile" class="table-list">
                        <template>
                            <el-table :data="deviceConf.data.slice(0,Math.round(deviceConf.data.length/2))"
                                      class="val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <p>{{deviceConfName[scope.row.name]}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <el-input v-if="isEdit" v-model="scope.row.data"></el-input>
                                            <p v-else>{{scope.row.data}}</p>
                                        </div>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </template>
                        <template>
                            <el-table :data="deviceConf.data.slice(Math.round(deviceConf.data.length/2))"
                                      class="val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <p>{{deviceConfName[scope.row.name]}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <el-input v-if="isEdit" v-model="scope.row.data"></el-input>
                                            <p v-else>{{scope.row.data}}</p>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                    <!--isMobile conf  -->
                    <div v-if="isMobile" class="table-list">
                        <template>
                            <el-table :data="tableData" class="mobile-val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <el-input v-model="scope.row.name"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <el-input v-if="isEdit" v-model="scope.row.data"></el-input>
                                            <p v-else>{{scope.row.data}}</p>
                                        </div>

                                    </template>

                                </el-table-column>

                            </el-table>
                        </template>

                    </div>
                </div>
                <loading v-else></loading>

            </el-card>

        </div>
        <div class="css-margin-top" v-if="deviceName.data.length">
            <el-card class="box-card" body-style>
                <div class="clearfix chars-header">
                    <span class="card-header-title">设备名称表</span>
                </div>
                <div>
                    <div class="device-name-item" v-for="name in deviceName.data">
                        {{name}}
                    </div>

                </div>

            </el-card>

        </div>

    </div>
</template>

<script>
    import {mapState} from "vuex"
    import pageHeader from '../../components/tempControl/header'
    import loading from '../../components/common/loading.vue'
    import Lib from '../../lib/lib'

    export default {

        name: "deviceConf",
        components: {
            pageHeader,
            loading
        },
        data() {
            return {
                option: {
                    sys_alias: ''
                },
                sys_alias: '',
                loading: true,
                isEdit: '',
                deviceConf: {
                    data: [],
                    time_stamp: ''
                },

                deviceName: {
                    data: '',
                    time_stamp: ''
                },

                //设备配置对应中文名
                deviceConfName: {
//焙烧窑总车位, int,0 ~255，不可空
                    bakeCars: '焙烧窑总车位',
//烧烘干窑总车位, int,0 ~255，不可空
                    dryCars: '烧烘干窑总车位',
//焙烧标准温度个数, int,0 ~255，不可空
                    bakeCarNum: '焙烧标准温度个数',
//烘干标准温度个数, int,0 ~255，不可空
                    dryCarNum: '烘干标准温度个数',
//K型热电偶总数, int,0 ~255，不可空
                    kiNum: 'K型热电偶总数',
//风机总数, int,0 ~255，不可空
                    aoNum: '风机总数',
//压力总数, int,0 ~255，不可空
                    piNum: '压力总数',
//4-20mA型总数(pi+ci+ao), int,0 ~255，不可空
                    aioNum: '4-20mA型总数',
//历史数据表中温度数据个数, int,0 ~255，不可空
                    hisKi: '历史数据表中温度数据个数',
//历史数据表中风机总数, int,0 ~255，不可空
                    hisAo: '历史数据表中风机总数',
//历史数据表中压力总数, int,0 ~255，不可空
                    hisPi: '历史数据表中压力总数',
//历史数据表中湿度总数, int,0 ~255，不可空
                    hisCi: '历史数据表中湿度总数',
//巡检提示、报警类型数 , int,0 ~255，不可空
                    detectNum: '巡检提示、报警类型数',
//自控提示、报警类型数 , int,0 ~255，不可空
                    autoNum: '自控提示、报警类型数',
//自控参数Uchar类型个数，int,0 ~255，不可空
                    zkcsUchar: '自控参数Uchar类型个数',
//自控参数Char类型个数，int,0 ~255，不可空
                    zkcsChar: '自控参数Char类型个数',
//自控参数Uint类型个数，int,0 ~255，不可空
                    zkcsUint: '自控参数Uint类型个数',
//自控参数Int类型个数，int,0 ~255，不可空
                    zkcsInt: '自控参数Int类型个数',
//自控参数Ulong类型个数，int,0 ~255，不可空
                    zkcsUlong: '自控参数Ulong类型个数',
//自控参数Long类型个数，int,0 ~255，不可空
                    zkcsLong: '自控参数Long类型个数',
//自控参数Float类型个数，int,0 ~255，不可空
                    zkcsFloat: '自控参数Float类型个数',
//自控变量Uchar类型个数，int,0 ~255，不可空
                    zkblUchar: '自控变量Uchar类型个数',
//自控变量Char类型个数，int,0 ~255，不可空
                    zkblChar: '自控变量Char类型个数',
//自控变量Uint类型个数，int,0 ~255，不可空
                    zkblUint: "自控变量Uint类型个数",
//自控变量Int类型个数，int,0 ~255，不可空
                    zkblInt: "自控变量Int类型个数",
//自控变量Ulong类型个数，int,0 ~255，不可空
                    zkblUlong: '自控变量Ulong类型个数',
//自控变量Long类型个数，int,0 ~255，不可空
                    zkblLong: '自控变量Long类型个数',
//自控变量Float类型个数，int,0 ~255，不可空
                    zkblFloat: '自控变量Float类型个数',
                    id_of_setinterval:''


                },
            }
        },
        computed: mapState({
            isMobile: state => state.isMobile,
            deviceInfo: state => state.deviceInfo,
            userInfo: state => state.userInfo,
            config: state => state.config,

        }),
        created() {
            this.sys_alias = Lib.M.creatAliasMeun(this.deviceInfo.alias_m)
            this.option.sys_alias = '1'
            this.initData(true);
        },
        beforeDestroy(){
            this.timingLoad('CLOSE')
        },
        methods: {
            initData(type) {
                this.loading = true;
                this.changeOption(type);
                this.timingLoad('OPEN');
            },
            changeOption(type){
                this.loading = true;
                this.confData = [];
                this.loadDeviceConf(type);
                this.loadDeviceName(type);
            },

            timingLoad(type){
                if (type === "OPEN") {
                    this.id_of_setinterval = setInterval(() => {
                        this.loadDeviceConf(false);
                        this.loadDeviceName(false);
                    }, this.config.refreshInterval?this.config.refreshInterval:30000);
                } else {
                    clearInterval(this.id_of_setinterval);
                }
            },
            loadDeviceConf(is_cache) {
                this.loading = true

                let params
                params = {
                    sys_alias: this.option.sys_alias,
                    is_cache: is_cache,
                    device_id: this.deviceInfo.device_id
                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceSetting(params, (data) => {
                    this.loading = false
                    if (data.payload && data.payload.data) {
                        try {
//                            this.deviceConf =JSON.parse(data.payload.data)
                            let jsonData = JSON.parse(data.payload.data)
                            delete jsonData.oother
                            delete jsonData.isSuccess
                            delete jsonData.msg
                            this.deviceConf.data = []
                            for (let key in jsonData) {
                                if(this.deviceConfName[key]){
                                    this.deviceConf.data.push({
                                        name: key,
                                        data: jsonData[key]
                                    })

                                }

                            }
                            this.deviceConf.time_stamp = data.payload.time_stamp

                        } catch (err) {

                        }
                    } else {
                        if (is_cache) {
                            this.initData(false)
                        }
                    }
                })
            },
            loadDeviceName(is_cache) {
                let params
                params = {
                    sys_alias: this.option.sys_alias,
                    is_cache: is_cache,
                    device_id: this.deviceInfo.device_id
                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceName(params, (data) => {
                    if (data.payload && data.payload.data) {
                        try {
                            let data =  JSON.parse(data.payload.data)

                            this.deviceName.data =data
                            this.deviceName.time_stamp = data.payload.time_stamp
                        } catch (err) {
                            console.error()

                        }
                    }
                })

            },
            openEdit() {
                this.isEdit = true;
                this.initData(false)
            },
            saveDeviceConf() {
                let params = {
                    payload: this.dealDeviceConf(),
                    device_id: this.deviceInfo.device_id,
                    sys_alias: this.option.sys_alias,


                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.setDeviceSetting(params, data => {
                    if(data.status_code==='SUCCEEDED'){
                        this.$message.success('操作成功')
                    }else{
                        this.$message.error('操作失败')
                    }

                })


            },
            dealDeviceConf() {
                let data = this.deviceConf.data,
                    json = {}
                data.forEach(v => {
                    json[v.name] = v.data
                })
                json.devNo = this.option.sys_alias * 1
                return JSON.stringify(json)
            },



        }


    }
</script>

<style scoped>
    .set-option {
        display: flex;
        justify-content: space-between
    }

    .table-list {
        display: flex;
        width: 100%;
    }

    .el-card box-card {
        width: 100%
    }

    .chars-header {
        font-size: 0.22rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.3rem;
    }

    .val-table {
        width: 50%;
    }

    .table-list .el-table__header-wrapper thead div {
        background: #71B7FF
    }

    .scope-input {
        display: flex;
        align-items: center;
    }

    .scope-input > .el-input {
        flex: 1;
    }

    .scope-input > span {
        margin: 0 5px;
    }

    .edit-input {
        margin: 9px 0
    }

    .device-name-item {
        display: inline-block;
        width: 125px;
        margin: 20px 0;
    }
</style>




// WEBPACK FOOTER //
// deviceConf.vue?3ac103bd